import { inject, Injectable } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { NotifyDialogComponent } from '../components/dialogs/notify-dialog/notify-dialog.component';
import { DialogRef } from '@angular/cdk/dialog';

@Injectable({
  providedIn: 'root'
})
export class NotifyDialogService {

  constructor() { }

  dialog = inject(MatDialog);

  openDialog(title: string, content: string, isConfirm: boolean = false, confirmCallback?: any, cancelCallback?: any) {
    const dialogRef = this.dialog.open(NotifyDialogComponent, {
      data: {
        title,
        content,
        isConfirm,
        confirmCallback,
        cancelCallback,
      },
    });
    return dialogRef.afterClosed();
  }

  closeDialog(){
    return this.dialog.closeAll();
  }
}
